/*
 * View for attributes
 */

define(["marionette", "./template/attributeListTemplate.html"], function (
  Marionette,
  AttributeListTemplate,
) {
  var AttributesListView = {};

  AttributesListView.attributeListLayout = Marionette.Layout.extend({
    template: AttributeListTemplate,
    regions: {
      list: "#list",
    },
  });

  return AttributesListView;
});
